class TableSummaryLayout {
  constructor () {
    this.gutterHeight = 0
    this.fixedRowScrollLeft = 0
    this.fixedRowScrollWidth = 0
    this.fixedNameGroupWidth = null
    this.gutterWidth = 0
    this.colsWidth = []
    this.fixedBottomTableRowHeights = []
    this.tableWidth = 0
    this.rightFixedTableWidth = 0
    this.leftFixedTableWidth = 0
  }

  updateLayout (options) {
    Object.assign(this, options)
  }
}

export default TableSummaryLayout